import { render, staticRenderFns } from "./BaseGridStatus.vue?vue&type=template&id=5784637b"
import script from "./BaseGridStatus.vue?vue&type=script&lang=js"
export * from "./BaseGridStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports